export const Modal = () => {
  return import(/* webpackChunkName: "Modal" */ '@/components/Modal')
}
